import React from "react";

import "./index.css"

const ErrorPage = () => {
    
    return (
        <div>
            The page you are looking for cannot be found. 
        </div>
    )
}

export default ErrorPage;